import { SmartPayPaymentExtendedModel, Supplier } from '../../../../../types/internal-api';

export enum SmartPayCustomerType {
    NewCustomer = 1,
    ExistingCustomerWithIntegration = 2,
    ExistingCustomerWithoutIntegration = 3,
}

export enum SmartPayOnboardingStatus {
    // User has no N1 integration added
    Unregistered = 1,
    // User has added the integration and stored their settings (journal, bank account), awaiting N1 email
    Pending = 2,
    // User has used their one-time password and begun onboarding
    CustomerVerifyingData = 3,
    // New customer type clicked continue onboarding while he was in CustomerVerifyingData state
    ContinuedOnboarding = 4,
    AwaitingCustomerInformation = 10,
    // User has completed N1 onboarding and is awaiting validation and approval by N1 and NETS
    CustomerReadyForValidation = 5,
    CustomerReadyForApproval = 6,
    // User has been validated and approved by N1 and NETS and can now make payments
    Completed = 7,
    // failure states
    Rejected = 8,
    Blocked = 9,
}

export enum SmartPayIntegrationError {
    // error codes also act as translation keys
    SMARTPAY_ONBOARDING_MODAL_ERROR_STATE_DEFAULT_MESSAGE = 'SMARTPAY_ONBOARDING_MODAL_ERROR_STATE_DEFAULT_MESSAGE',
    SMARTPAY_ONBOARDING_MODAL_ERROR_STATE_ACCOUNT_NUMBER_LENGTH_INVALID = 'SMARTPAY_ONBOARDING_MODAL_ERROR_STATE_ACCOUNT_NUMBER_LENGTH_INVALID',
    SMARTPAY_ONBOARDING_MODAL_ERROR_STATE_BANK_NOT_SUPPORTED = 'SMARTPAY_ONBOARDING_MODAL_ERROR_STATE_BANK_NOT_SUPPORTED',
}

export interface SmartPayIntegrationModel {
    daybook?: number;
    paymentAccount?: number;
    feeAccount?: number;
    novemberFirstCustomerNumber: string;
    cvr: string;
    contact: string;
    telephone: string;
    email: string;
    customerType?: SmartPayCustomerType;
    status: SmartPayOnboardingStatus;
    onboardingNfUrl: string;
    lastUpdatedDate?: Date;
    autoWithdrawActiveDate?: Date;
    subscriptionType: 0 | 1 | 2;
    unsubscriptionDate?: Date;
}

export const SMARTPAY_SIGNUP_STEPS = Object.freeze({
    CONSENT: 'CONSENT',
    SELECT_PLAN: 'SELECT_PLAN',
    COMPANY_DATA: 'COMPANY_DATA',
    USER_DATA: 'USER_DATA',
    PAYMENT_DATA: 'PAYMENT_DATA',
    INFORMATION_SENT: 'INFORMATION_SENT',
});

export const SMARTPAY_PLAN_OPTIONS = [
    {
        id: 1,
        name: 'SMARTPAY_ONBOARDING_MODAL_PLAN_OPTION_STANDARD_NAME',
        price: 'SMARTPAY_ONBOARDING_MODAL_PLAN_OPTION_STANDARD_PRICE',
        features: 'SMARTPAY_ONBOARDING_MODAL_PLAN_OPTION_STANDARD_FEATURES',
    },
    {
        id: 2,
        name: 'SMARTPAY_ONBOARDING_MODAL_PLAN_OPTION_SUBSCRIPTION_NAME',
        price: 'SMARTPAY_ONBOARDING_MODAL_PLAN_OPTION_SUBSCRIPTION_PRICE',
        features: 'SMARTPAY_ONBOARDING_MODAL_PLAN_OPTION_SUBSCRIPTION_FEATURES',
    },
];

// PAYMENTS

export interface SuppliersResponse {
    pagination: PaginationResponse;
    data: Supplier[];
}
export interface PaymentsResponse {
    pagination: PaginationResponse;
    data: SmartPayPaymentExtendedModel[];
}

export interface PaginationResponse {
    count: number;
    pageSize: number;
    returnAll: boolean;
    skipPages: number;
}

export interface SmartPayUpcomingPaymentsFilters {
    fromDate: Date;
    toDate: Date;
    supplier: string;
    status: string;
    includeDaybooks: boolean;
}

export enum UpcomingPaymentStatuses {
    New = 'NEW',
    PendingApproval = 'PENDING_APPROVAL',
    Scheduled = 'SCHEDULED',
    Invalid = 'INVALID',
    PartiallyApproved = 'PARTIALLY_APPROVED',
    Rejected = 'REJECTED',
    TradeReverted = 'TRADE_REVERTED',
    TransferForbidden = 'TRANSFER_FORBIDDEN',
    Canceled = 'CANCELLED',
    Failed = 'Failed',
}
